import ComponentName from '../constant/ComponentName';
import CollectionNames from '../constant/CollectionNames';
import { ComponentCategory, EnrichedComponentCategory } from '../domain/category/CategoryOperationDomains';
import { subscribe } from '@trlogic/client-js';
import generateUUIDV4 = subscribe.generateUUIDV4;

class ComponentCategoryUtil {
  public static getItemCollectionName(component: ComponentName): string {
    switch (component) {
      case ComponentName.RULE:
        return CollectionNames.RULES;
      case ComponentName.TRANSACTION:
        return CollectionNames.TRANSACTIONS;
      case ComponentName.LIST:
        return CollectionNames.LISTS;
      case ComponentName.VELOCITY:
      case ComponentName.API_VARIABLE:
      case ComponentName.QUERY_VARIABLE:
      case ComponentName.BASIC_VARIABLE:
      case ComponentName.LIST_VARIABLE:
      case ComponentName.ENRICHMENT:
        return CollectionNames.ENRICHMENTS;
      case ComponentName.CONNECTION:
        return CollectionNames.CONNECTIONS;
      case ComponentName.STREAM:
        return CollectionNames.STREAMS;
      case ComponentName.STRUCT:
        return CollectionNames.DATA_STRUCTURES;
      case ComponentName.CONFIGURATION:
      case ComponentName.CASE:
        return CollectionNames.CASE_SETTINGS;
      case ComponentName.ACTION:
        return CollectionNames.ACTIONS;
      case ComponentName.AI_MODEL:
        return CollectionNames.AI_MODELS;
      case ComponentName.TRACKER:
        return CollectionNames.TRACKERS;
      case ComponentName.POLICY:
      case ComponentName.ASSESSMENT:
        return CollectionNames.CRA;
      default:
        throw new Error('Unsupported category type: ' + component);
    }
  }

  public static getCollectionName(component: ComponentName): string {
    switch (component) {
      case ComponentName.RULE:
        return CollectionNames.RULE_CATEGORIES;
      case ComponentName.TRANSACTION:
        return CollectionNames.TRANSACTION_CATEGORIES;
      case ComponentName.LIST:
        return CollectionNames.LIST_CATEGORIES;
      case ComponentName.ENRICHMENT:
        return CollectionNames.ENRICHMENT_CATEGORIES;
      case ComponentName.CONNECTION:
        return CollectionNames.CONNECTION_CATEGORIES;
      case ComponentName.STREAM:
        return CollectionNames.STREAM_CATEGORIES;
      case ComponentName.STRUCT:
        return CollectionNames.STRUCTURE_CATEGORIES;
      case ComponentName.CONFIGURATION:
        return CollectionNames.CASE_CONFIGURATION_CATEGORIES;
      case ComponentName.ACTION:
        return CollectionNames.ACTION_CATEGORIES;
      case ComponentName.AI_MODEL:
        return CollectionNames.AI_MODEL_CATEGORIES;
      case ComponentName.TRACKER:
        return CollectionNames.TRACKER_CATEGORIES;
      case ComponentName.POLICY:
      case ComponentName.ASSESSMENT:
        return CollectionNames.CRA_CATEGORIES;
      default:
        throw new Error('Unsupported category type: ' + component);
    }
  }

  public static getRoleNamesByComponent(component: ComponentName): string {
    switch (component) {
      case ComponentName.ADMIN:
      case ComponentName.ADMIN_TENANT:
        return 'Admin';
      case ComponentName.ADMIN_USER:
        return 'Admin';
      case ComponentName.ADMIN_GROUP:
        return 'Group';
      case ComponentName.ADMIN_ROLE:
        return 'Role';
      case ComponentName.ADMIN_AUDIT_LOG:
        return 'Audit';
      case ComponentName.TRANSACTION:
        return 'Transaction';
      case ComponentName.ENTITY:
        return 'Entity';
      case ComponentName.ENRICHMENT:
        return 'Enrichment';
      case ComponentName.API_VARIABLE:
        return 'EnrichmentApi';
      case ComponentName.BASIC_VARIABLE:
        return 'EnrichmentBasic';
      case ComponentName.LIST_VARIABLE:
        return 'EnrichmentList';
      case ComponentName.QUERY_VARIABLE:
        return 'EnrichmentQuery';
      case ComponentName.VELOCITY:
        return 'EnrichmentVelocity';
      case ComponentName.STRUCT:
        return 'Struct';
      case ComponentName.CONNECTION:
        return 'Connection';
      case ComponentName.LIST:
        return 'List';
      case ComponentName.RULE:
        return 'Rule';
      case ComponentName.STREAM:
        return 'Stream';
      case ComponentName.CONFIGURATION:
        return 'CaseConfiguration';
      case ComponentName.CASE:
        return 'Cases';
      case ComponentName.SANDBOX:
        return 'Sandbox';
      case ComponentName.ACTION:
        return 'Action';
      case ComponentName.WATCHLIST:
        return 'Watchlist';
      case ComponentName.CUSTOM_LIST:
        return 'CustomList';
      case ComponentName.WATCHLIST_ALERT:
        return 'WatchlistAlert';
      case ComponentName.AI_MODEL:
        return ComponentName.AI_MODEL;
      case ComponentName.TRACKER:
        return ComponentName.TRACKER
      case ComponentName.POLICY:
      case ComponentName.ASSESSMENT:
        return ComponentName.POLICY;

      default:
        console.log(component);
        throw new Error('Unsupported component name for roles');
    }
  }

  public static getLastNode = (key: string, index: number = 1) => {
    const node = key.split('.');
    let _index = index;
    if (_index > node.length) {
      _index = node.length;
    }
    return node[node.length - _index].substring(1, node[node.length - _index].length);
  };

  public static enrichMainCategory = (
    categoryId: string,
    allCategories: Array<ComponentCategory>,
    path: string[] = [],
    categoryMap: Record<string, EnrichedComponentCategory> = {},
  ): EnrichedComponentCategory | undefined => {
    const category = allCategories.find((c) => c.id == categoryId);
    if (category) {
      const categories: Array<EnrichedComponentCategory> = category.categories
        .map((_category) => {
          return ComponentCategoryUtil.enrichMainCategory(_category, allCategories, [...path, category.id], categoryMap);
        })
        .filter((c) => c != undefined) as Array<EnrichedComponentCategory>;
      const enrichCategory = {
        name: category.name,
        id: category.id,
        path: [...path, category.id],
        categories,
        components: category.components,
        collaborators: [],
      };
      categoryMap[enrichCategory.path.join('.')] = enrichCategory;
      return enrichCategory;
    }
  };

  public static getNewCategory(name: string = ''): ComponentCategory | EnrichedComponentCategory {
    return {
      name: name,
      id: name == '' ? '' : generateUUIDV4(),
      categories: [],
      components: [],
      collaborators: [],
    };
  }
}

export default ComponentCategoryUtil;
